module.exports = __webpack_public_path__ + "img/b_Rentrit_2.2e72cb11.jpeg";